import { SET_RES_ORDER_SUBMIT } from '../actions';

const reservationordersubmit = (state = [], action) => {
  switch (action.type) {
    case SET_RES_ORDER_SUBMIT:
      return [...action.value];
    default: return state;
  }
}

export default reservationordersubmit;
